import { Component, inject, Input } from "@angular/core";
import { ProposalHistory } from "@app/core/domain/proposal-history";
import { Constants } from "@core/constants";
import {
  IonButton,
  IonContent,
  IonHeader,
  IonIcon,
  IonTitle,
  IonToolbar,
  ModalController,
} from "@ionic/angular/standalone";
import { TranslatePipe } from "@ngx-translate/core";
import { HistoryInfoComponent } from "./history-item/history-info.component";

@Component({
  selector: "pa-show-history-modal",
  templateUrl: "./show-history-modal.component.html",
  styleUrls: ["./show-history-modal.component.scss"],
  imports: [HistoryInfoComponent, TranslatePipe, IonHeader, IonToolbar, IonButton, IonTitle, IonIcon, IonContent],
})
export class ShowHistoryModalComponent {
  @Input() title!: string;
  @Input() history: ProposalHistory | undefined;
  private readonly modalCtrl = inject(ModalController);

  dismiss(): Promise<boolean> {
    return this.modalCtrl.dismiss(null, Constants.BUTTON_ACTION_OK);
  }
}
